import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormDataItem, FormElementItem } from 'src/app/interfaces/form-data';
import { ActionsService } from 'src/app/services/actions.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-complete-action',
  templateUrl: './complete-action.component.html',
})
export class CompleteActionComponent implements OnInit {
  /* da qui in poi è la copia di resource-renewal component è da adattare*/
  @Input() item: any;

  formData: any;

  customFunctions = {
    refresh: (field: FormDataItem, formData: FormData) => {
      console.log('$refresh()', field, formData);
    },
    action: (element: FormElementItem, formData: FormData) => {
      console.log('$action()', element, formData);
    },
  };

  constructor(
    private readonly modalService: NgbModal,
    private readonly appService: ActionsService,
    private readonly activeModal: NgbActiveModal,
    private readonly spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.getFormData(this.item.id);
    console.log(this.item);
  }
  getFormData(actionId: string) {
    this.spinnerService.open();
    this.appService.getPendingAction(actionId).subscribe((data: any) => {
      this.formData = {
        fields: data.form.fields,
        elements: data.form.elements,
      };
      this.spinnerService.close();
    });
  }

  manualComplete(event: any) {
    if (event.valid) {
      this.activeModal.close({
        form: this.formData,
      });
    }
  }
  onEvent(eventName: any, $event: any) {
    console.log('(' + eventName + ')', $event);
  }
  closeModal() {
    this.modalService.dismissAll();
  }
}
